interface IStarProps {
  className?: string;
}

export const Star = ({ className }: IStarProps) => (
  <svg className={className} viewBox="0 0 95 95">
    <path d="M45.218 4.402c1.255-2.242 3.31-2.242 4.563 0l11.606 20.726c1.255 2.242 4.301 4.509 6.769 5.04l22.822 4.906c2.469.532 3.103 2.533 1.409 4.448L76.741 57.239c-1.693 1.915-2.857 5.585-2.586 8.154l2.5 23.757c.27 2.57-1.393 3.808-3.693 2.75l-21.278-9.776c-2.3-1.057-6.065-1.057-8.367 0L22.04 91.901c-2.301 1.058-3.963-.18-3.692-2.749l2.498-23.757c.27-2.57-.894-6.24-2.586-8.155L2.612 39.522c-1.693-1.915-1.058-3.918 1.41-4.448l22.822-4.906c2.469-.532 5.515-2.798 6.769-5.042L45.218 4.401v.001z" />
  </svg>
);
